import { useSyncExternalStore } from 'react';
import { parseAccountId, parseCredentialTab, parseRoute, type CredentialTab, type Route } from '@/lib/route';

function subscribe(onChange: () => void): () => void {
  window.addEventListener('hashchange', onChange);
  return () => window.removeEventListener('hashchange', onChange);
}

/** The page the URL's hash names; links change it, so the back button walks the pages. */
export function useRoute(): Route {
  return useSyncExternalStore(subscribe, () => parseRoute(window.location.hash));
}

/** The credentials page's tab, from the same hash, so a tab can be linked to. */
export function useCredentialTab(): CredentialTab {
  return useSyncExternalStore(subscribe, () => parseCredentialTab(window.location.hash));
}

/** The account the accounts page is showing, or undefined for the listing of them all. */
export function useAccountId(): string | undefined {
  return useSyncExternalStore(subscribe, () => parseAccountId(window.location.hash));
}
